import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ============================================================================
// DemoTranslator - traduction FR -> EN a la volee, cote client uniquement,
// pour l'enregistrement des videos de demo App Review Meta (l'UI de l'app
// doit apparaitre en anglais - exigence explicite de Meta, section 4 des
// motifs de rejet). Ne modifie AUCUN composant existant : on parcourt le DOM
// deja rendu et on remplace le texte, via un MutationObserver qui reagit a
// chaque changement d'ecran (navigation entre Dashboard/FacebookPageConnect/
// BotConfigPanel etc, qui sont tous rendus dans le meme arbre React).
//
// Activation : ajouter ?demo=en a l'URL (ex: https://teckia.tdidigital.io/login?demo=en)
// Aucun impact sur les vrais clients : ne fait rien si le parametre est absent.
// ============================================================================

const DICTIONARY = {
  // ── Header / nav commun ──
  'Bonjour,': 'Hello,',
  'Déconnexion': 'Logout',
  'Chargement...': 'Loading...',
  'Acheter Crédits': 'Buy Credits',
  'Crédits': 'Credits',

  // ── ClientDashboard : cartes de services ──
  'Page Facebook': 'Facebook Page',
  'Agent IA, ventes, conversations et alertes de votre page': 'AI agent, sales, conversations and alerts for your page',
  'Connexion officielle': 'Official connection',
  'WhatsApp': 'WhatsApp',
  'Agent IA, ventes, conversations et alertes sur WhatsApp': 'AI agent, sales, conversations and alerts on WhatsApp',
  'Nouveau': 'New',
  'TeckiA Image Studio': 'TeckiA Image Studio',
  'Génération image IA — 600 Ar/image': 'AI image generation — 600 Ar/image',
  'TeckiA IA Studio Vidéo': 'TeckiA AI Video Studio',
  'Génération vidéo + storyboard scène par scène': 'Video generation + scene-by-scene storyboard',
  'TeckiA Pub Vidéos': 'TeckiA Video Ads',
  'Vidéos publicitaires IA 30s': '30s AI advertising videos',
  'Marketing-Studio': 'Marketing Studio',
  'Images Pub & Vidéos': 'Ad Images & Videos',
  'Universal Marketing': 'Universal Marketing',
  'Marketing produits universel': 'Universal product marketing',
  'Surveillance Commentaires': 'Comment Monitoring',
  'Détection et réponse auto': 'Auto detection and reply',
  'WhatsApp Bot IA': 'WhatsApp AI Bot',
  'Conversations intelligentes WhatsApp': 'Smart WhatsApp conversations',
  'Agent IA Réceptionniste': 'AI Receptionist Agent',
  'Répondeur vocal intelligent': 'Smart voice answering',
  'Agent IA + Site Web': 'AI Agent + Website',
  'Réceptionniste + Site vitrine': 'Receptionist + showcase website',
  'Actif': 'Active',
  'Non abonné': 'Not subscribed',
  "service actif": 'active service',
  "services actifs": 'active services',
  "Salut, c'est TeckiA": "Hi, this is TeckiA",
  "Salut, TeckiA est à ton service": "Hi, TeckiA is at your service",
  'Aucun service actif pour le moment': 'No active service at the moment',
  'Découvrez nos services intelligents': 'Discover our smart services',
  "Automatisez vos réponses, gérez vos conversations, boostez vos ventes avec l'intelligence artificielle":
    'Automate your replies, manage your conversations, boost your sales with artificial intelligence',
  'Bot IA Intelligent': 'Smart AI Bot',
  'Surveillance Auto': 'Auto Monitoring',
  'Marketing IA': 'AI Marketing',
  'Voir les abonnements': 'View subscriptions',
  'Essai gratuit disponible': 'Free trial available',
  'Sans engagement': 'No commitment',
  'Support 24/7': '24/7 Support',
  '0 crédit — Achetez': '0 credit — Buy now',
  '0 crédit': '0 credit',

  // ── FacebookPageConnect : confirmation explicite des permissions accordées ──
  'Permissions accordées pour': 'Permissions granted for',
  'Aucune permission détectée — vérifiez la connexion Facebook.': 'No permission detected — please check the Facebook connection.',
  'Voir la liste de vos Pages': 'View the list of your Pages',
  'Envoyer et recevoir des messages sur votre Page': 'Send and receive messages on your Page',
  'Gérer les paramètres de votre Page': "Manage your Page's settings",
  'Lire les publications et commentaires de votre Page': "Read your Page's posts and comments",
  'Lire le contenu publié par les visiteurs sur votre Page': 'Read content posted by visitors on your Page',
  'Créer, modifier et supprimer des publications sur votre Page': 'Create, edit and delete posts on your Page',
  'Répondre aux commentaires et gérer les interactions de votre Page': "Reply to comments and manage your Page's engagement",
  'Gérer les ressources de votre compte professionnel': 'Manage your business account assets',

  // ── FacebookPageConnect ──
  'Connectez votre page et activez votre agent IA': 'Connect your page and activate your AI agent',
  'Un vrai humain configure votre agent': 'A real human configures your agent',
  "Chez TDI DIGITAL, votre agent IA Page Facebook n'est pas livré tel quel : notre équipe le configure et le suit personnellement pour garantir une vraie qualité de service.":
    "At TDI DIGITAL, your Facebook Page AI agent isn't delivered as-is: our team personally configures and monitors it to guarantee real service quality.",
  'Comment ça marche ?': 'How does it work?',
  'Connectez-vous': 'Log in',
  'Cliquez sur le bouton bleu et connectez-vous avec votre compte Facebook.': 'Click the blue button and log in with your Facebook account.',
  'Choisissez votre page': 'Choose your page',
  'Sélectionnez la page de votre business dans la liste.': 'Select your business page from the list.',
  'Activez votre agent IA': 'Activate your AI agent',
  'Il répondra automatiquement à vos clients, 24h/24.': 'It will automatically reply to your customers, 24/7.',
  'Connexion en cours...': 'Connecting...',
  'Connecter une autre page': 'Connect another page',
  'Connecter avec Facebook': 'Connect with Facebook',
  "Connexion sécurisée via Facebook. Nous n'accédons jamais à votre mot de passe.":
    "Secure login via Facebook. We never access your password.",
  'Popup bloquée par le navigateur. Autorisez les popups pour ce site.': 'Popup blocked by the browser. Please allow popups for this site.',
  'Erreur serveur': 'Server error',
  'Choisissez la page à connecter :': 'Choose the page to connect:',
  'Cliquez pour connecter cette page': 'Click to connect this page',
  'Vos pages connectées': 'Your connected pages',
  'Connexion expirée — reconnexion nécessaire': 'Connection expired — reconnection needed',
  'Agent IA actif — il répond à vos clients': 'AI agent active — it replies to your customers',
  'Agent IA en pause': 'AI agent paused',
  'Mettre en pause': 'Pause',
  "Activer l'agent IA": 'Activate the AI agent',
  'Configuration en attente par notre équipe': 'Configuration pending — being set up by our team',
  'Reconnectez votre Page avant de réactiver': 'Reconnect your Page before reactivating',
  "La connexion à cette Page a expiré (souvent parce que la personne qui l'a connectée a perdu son accès à la Page sur Facebook). Déconnectez puis reconnectez la Page pour que l'agent IA fonctionne à nouveau.":
    "The connection to this Page has expired (often because the person who connected it lost their access to the Page on Facebook). Disconnect then reconnect the Page for the AI agent to work again.",
  "Notre équipe finalise la configuration de votre agent IA. Vous pourrez l'activer très bientôt.":
    'Our team is finalizing your AI agent configuration. You will be able to activate it very soon.',
  "L'agent IA ne répondra plus sur cette page.": 'The AI agent will no longer reply on this page.',
  'Déconnecter la page': 'Disconnect the page',
  'Page déconnectée': 'Page disconnected',
  'Ventes': 'Sales',
  'Conversations': 'Conversations',
  'Alertes Telegram': 'Telegram Alerts',
  'Configurer mon agent': 'Configure my agent',
  'TeckiA CM': 'TeckiA CM',
  'Messenger': 'Messenger',
  'Connexion temporaire gérée par notre équipe, distincte de votre Page Facebook officielle ci-dessus.':
    'Temporary connection managed by our team, separate from your official Facebook Page above.',

  // ── BotConfigPanel ──
  'Configuration gérée par l\'équipe TDI DIGITAL': 'Configuration managed by the TDI DIGITAL team',
  "Votre agent IA est configuré et optimisé pour vous par nos experts.":
    'Your AI agent is configured and optimized for you by our experts.',
  'Contactez-nous pour toute modification': 'Contact us for any changes',
  'Agent IA actif': 'AI agent active',
  'Il répond automatiquement aux messages de la page': 'It automatically replies to page messages',
  'Il ne répond à aucun message': 'It does not reply to any message',
  'Votre agent': 'Your agent',
  'Qui est-il et comment parle-t-il ?': 'Who is it and how does it speak?',
  "Nom de l'agent": 'Agent name',
  'Langue des réponses': 'Reply language',
  'Automatique (langue du client)': 'Automatic (customer language)',
  'Malagasy uniquement': 'Malagasy only',
  'Français uniquement': 'French only',
  'Malagasy + Français': 'Malagasy + French',
  "Ton de l'agent": 'Agent tone',
  'Amical': 'Friendly',
  'Chaleureux et proche': 'Warm and personable',
  'Professionnel': 'Professional',
  'Poli et précis': 'Polite and precise',
  'Énergique': 'Energetic',
  'Enthousiaste': 'Enthusiastic',
  'Concis': 'Concise',
  'Réponses courtes et naturelles, comme un humain': 'Short and natural replies, like a human',
  "Mission de l'agent": 'Agent mission',
  'Vendeur': 'Sales',
  'Vend et conclut les commandes dans Messenger': 'Sells and closes orders inside Messenger',
  'Support': 'Support',
  'Aide les clients existants': 'Helps existing customers',
  'Accueil': 'Welcome',
  'Informe et oriente les visiteurs': 'Informs and guides visitors',
  'Votre entreprise': 'Your business',
  "Ce que l'agent doit savoir sur vous": 'What the agent should know about you',
  "Décrivez votre activité (l'agent s'en servira pour répondre)": 'Describe your business (the agent will use this to reply)',
  'Vos produits & services': 'Your products & services',
  "Avec les prix exacts — l'agent ne connaîtra que ceux-là": "With exact prices — the agent will only know these",
  'Nom du produit / service': 'Product / service name',
  'Prix': 'Price',
  'Description courte (optionnel)': 'Short description (optional)',
  'Ajouter un produit / service': 'Add a product / service',
  'Documents & catalogues': 'Documents & catalogs',
  'PDF, Word, ou simple photo — extraction automatique par IA': 'PDF, Word, or a simple photo — automatic AI extraction',
  'Catalogue produits': 'Product catalog',
  'Document entreprise': 'Business document',
  'Lecture et analyse par l\'IA...': 'Reading and analyzing with AI...',
  'Uploader un fichier ou une photo': 'Upload a file or a photo',
  'PDF, DOCX, image (menu, flyer, liste de prix...) — OCR automatique': 'PDF, DOCX, image (menu, flyer, price list...) — automatic OCR',
  'Retirer ce document du cerveau de l\'agent ?': "Remove this document from the agent's knowledge?",
  'Photos envoyées par l\'agent': 'Photos sent by the agent',
  "L'agent envoie la bonne photo dans Messenger quand un client demande à voir":
    'The agent sends the right photo in Messenger when a customer asks to see',
  "Nom de la photo (l'agent s'en sert pour choisir)": 'Photo name (the agent uses this to choose)',
  'Quand l\'envoyer ?': 'When to send it?',
  'Upload en cours...': 'Uploading...',
  "Choisir l'image (JPG/PNG — max 5 MB, 15 photos max)": 'Choose the image (JPG/PNG — max 5 MB, up to 15 photos)',
  'Donnez d\'abord un nom à la photo': 'Please name the photo first',
  'Supprimer cette photo ?': 'Delete this photo?',
  'Supprimer': 'Delete',
  'Questions fréquentes (FAQ)': 'Frequently Asked Questions (FAQ)',
  "Réponses exactes prioritaires — l'agent les utilise mot pour mot": "Priority exact answers — the agent uses them word for word",
  'Question du client': "Customer's question",
  "Réponse exacte de l'agent": "Agent's exact answer",
  'Ajouter une question / réponse': 'Add a question / answer',
  'Détection des ventes': 'Sales detection',
  'Quand compter une vente et vous alerter sur Telegram ?': 'When to count a sale and alert you on Telegram?',
  'Paiement confirmé': 'Payment confirmed',
  'Paiement ou intention': 'Payment or intent',
  'Commande complète': 'Complete order',
  'Mots de paiement confirmé': 'Confirmed-payment keywords',
  'Mots d\'intention de paiement': 'Payment-intent keywords',
  'Prise de rendez-vous': 'Appointment booking',
  "Optionnel — l'agent peut planifier des RDV si votre activité en a besoin": 'Optional — the agent can schedule appointments if your business needs it',
  "Activé : l'agent collecte nom, téléphone, date et heure, puis vous alerte sur Telegram":
    "Enabled: the agent collects name, phone, date and time, then alerts you on Telegram",
  "Désactivé : l'agent ne propose jamais de rendez-vous (recommandé pour un vendeur)":
    "Disabled: the agent never offers appointments (recommended for a sales agent)",
  'Mots-clés qui déclenchent la prise de RDV': 'Keywords that trigger appointment booking',
  'Réponse aux commentaires': 'Comment replies',
  'Quand quelqu\'un commente une publication de votre Page': 'When someone comments on a post from your Page',
  'Envoyer un message privé automatique': 'Send an automatic private message',
  "L'IA lit le commentaire et répond en message privé (Messenger) à la personne.":
    'The AI reads the comment and replies privately (Messenger) to the person.',
  'Répondre aussi publiquement au commentaire': 'Also reply publicly to the comment',
  "Une réponse visible sous le commentaire, en plus (ou à la place) du message privé.":
    'A visible reply under the comment, in addition to (or instead of) the private message.',
  'Message fixe': 'Fixed message',
  'Toujours le même texte': 'Always the same text',
  'Généré par l\'IA': 'AI-generated',
  'Publications à surveiller': 'Posts to monitor',
  'Toutes les publications': 'All posts',
  'Publications sélectionnées': 'Selected posts',
  "Collez le lien du post Facebook": 'Paste the Facebook post link',
  'Nom (optionnel)': 'Name (optional)',
  'Ajouter': 'Add',
  "Aucune publication sélectionnée — aucun commentaire ne sera traité tant que la liste est vide.":
    'No post selected — no comment will be processed while the list is empty.',
  'Activer': 'Enable',
  'Désactiver': 'Disable',
  'Publication test (bêta)': 'Test post (beta)',
  'Publie un post directement sur votre Page — sert à tester le futur module Community Manager IA':
    'Publishes a post directly on your Page — used to test the upcoming AI Community Manager module',
  'Texte du post': 'Post text',
  'URL image (optionnel)': 'Image URL (optional)',
  'Publier sur la Page': 'Publish to the Page',
  'Publié sur la Page !': 'Published to the Page!',
  'Passage à un humain': 'Handoff to a human',
  "Quand l'agent doit vous laisser la main": 'When the agent should hand off to you',
  'Mots-clés qui déclenchent le transfert (séparés par des virgules)': 'Keywords that trigger the handoff (comma-separated)',
  'Message envoyé au client lors du transfert': 'Message sent to the customer during the handoff',
  "L'agent transfère aussi automatiquement quand il ne connaît pas la réponse — il n'invente jamais.":
    "The agent also automatically hands off when it doesn't know the answer — it never makes things up.",
  'Connectez Telegram (onglet Alertes) pour être prévenu instantanément.': 'Connect Telegram (Alerts tab) to be notified instantly.',
  'Consignes spécifiques': 'Specific instructions',
  'Optionnel — instructions particulières pour votre agent': 'Optional — special instructions for your agent',
  "Enregistrer la configuration de l'agent": 'Save agent configuration',
};

// Entrees triees des plus longues aux plus courtes, pour que les phrases completes
// soient remplacees avant que des sous-chaines plus courtes ne les "grignotent".
const ENTRIES = Object.entries(DICTIONARY).sort((a, b) => b[0].length - a[0].length);

function translateText(text) {
  let out = text;
  for (const [fr, en] of ENTRIES) {
    if (out.includes(fr)) out = out.split(fr).join(en);
  }
  return out;
}

function walk(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    const translated = translateText(node.nodeValue);
    if (translated !== node.nodeValue) node.nodeValue = translated;
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    for (const child of node.childNodes) walk(child);
  }
}

export default function DemoTranslator() {
  const location = useLocation();
  const active = new URLSearchParams(location.search).get('demo') === 'en';

  useEffect(() => {
    if (!active) return;

    let scheduled = false;
    let observer = null;

    // Un seul balayage complet, regroupe toutes les mutations d'une meme rafale (ex: un
    // gros panneau qui se monte en plusieurs setState) au lieu d'un balayage recursif par
    // mutation individuelle - sinon, sur un composant volumineux (BotConfigPanel, 891 lignes,
    // plusieurs chargements successifs), les balayages s'empilent plus vite qu'ils ne se
    // terminent et bloquent le thread JS avant meme que l'appel reseau parte (vu en prod le
    // 2026-08-31 : "Configurer mon agent" restait bloque en chargement infini).
    const runWalk = () => {
      scheduled = false;
      if (!observer) return;
      observer.disconnect();
      walk(document.body);
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    };

    const scheduleWalk = () => {
      if (scheduled) return;
      scheduled = true;
      // setTimeout simple plutot que requestIdleCallback : ce dernier peut se faire attendre
      // indéfiniment si le navigateur ne se considère jamais "idle" pendant une interaction
      // active - on veut un delai predictible, pas "des que possible mais peut-etre jamais vite".
      window.setTimeout(runWalk, 150);
    };

    walk(document.body);
    observer = new MutationObserver(scheduleWalk);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => observer && observer.disconnect();
  }, [active]);

  return null;
}
